import React from "react";
import { CSVLink } from "react-csv";
import commonFunctions from "../../common/Functions";

const DataView = ({ 
  data, 
  type, 
  headers, 
  loading, 
  showData, 
  setShowData, 
  fromDate, 
  toDate, 
  chartComponent 
}) => {
  return (
    <div className="data-view-container">
      <div className="d-flex justify-content-between align-items-center mb-3">
        {data && data.length > 0 && (
          <div className="text-muted">
            Showing {data.length} {type === 'invoices' ? 'invoices' : 'transactions'}
          </div>
        )}
        <div className="d-flex align-items-center">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowData(!showData)}
          >
            {showData ? "Hide" : "Show"} {type === 'invoices' ? 'Invoices' : 'Transactions'}
          </button>
          {data && data.length > 0 && (
            <CSVLink
              data={data}
              headers={headers}
              filename={
                `${fromDate.getMonth() + 1}-${fromDate.getFullYear()}_to_${toDate.getMonth() + 1}-${toDate.getFullYear()}_${type}.csv`
              }
              className="btn btn-outline-success"
            >
              <i className="fa fa-download me-1"></i> Export CSV
            </CSVLink>
          )}
        </div>
      </div>

      {!loading && data && data.length > 0 && (
        <>
          {chartComponent}
          {showData && (
            <div className="table-container">
              <div className="table-wrapper">
                <table className="styled-table">
                  <thead>
                    {type === 'invoices' ? (
                      <tr>
                        <th>Number</th>
                        <th>CLIENT NAME</th>
                        <th>INVOICE DATE</th>
                        <th>Start-End</th>
                        <th>PRICE (INCL VAT)</th>
                        <th>ACCOUNT</th>
                        <th>transactionNumber</th>
                        <th>Paid At</th>
                        <th>CATEGORY</th>
                        <th>Category Key</th>
                        <th>transactionAmount1</th>
                        <th>CATEGORY2</th>
                        <th>Category Key2</th>
                        <th>transactionAmount2</th>
                        <th>User Balance</th>
                        <th>Cumulative Amount</th>
                      </tr>
                    ) : (
                      <tr>
                        <th>Number</th>
                        <th>Label</th>
                        <th>Amount</th>
                        <th>Category</th>
                        <th>Account</th>
                        <th>Invoice Number</th>
                        <th>Cash Date</th>
                        <th>User Balance (USD)</th>
                        <th>Cumulative (USD)</th>
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {data && data.length > 0
                      ? data.map((item, index) => {
                          return type === 'invoices' ? (
                            <tr key={index}>
                              <td>{item.Number}</td>
                              <td>{item["CLIENT NAME"]}</td>
                              <td>{item["INVOICE DATE"]}</td>
                              <td>{item["Start Date"]} - {item["End Date"]}</td>
                              <td>{item["PRICE (INCL VAT)"]}</td>
                              <td>{item["ACCOUNT"]}</td>
                              <td>{item["transactionNumber"]}</td>
                              <td>{item["Paid At"]}</td>
                              <td>{item["CATEGORY"]}</td>
                              <td>{item["Category Key"]}</td>
                              <td>{item["transactionAmount1"]}</td>
                              <td>{item["CATEGORY2"]}</td>
                              <td>{item["Category Key2"]}</td>
                              <td>{item["transactionAmount2"]}</td>
                              <td>{item["User Balance"]}</td>
                              <td>{item["Cumulative Amount"]}</td>
                            </tr>
                          ) : (
                            <tr key={index}>
                              <td>{item["Transaction Number"]}</td>
                              <td>{item.Label}</td>
                              <td>
                                {commonFunctions.CommaFormatted(item["Amount"])} {item["Currency"]}
                              </td>
                              <td>
                                {item["Category"]} - {item["Category Key"]}
                              </td>
                              <td>{item["Account"]}</td>
                              <td>{item["Invoice Number"]}</td>
                              <td>{item["Cash Date"]}</td>
                              <td>{item["User Balance"]}</td>
                              <td>{item["Cumulative Amount"]}</td>
                            </tr>
                          );
                        })
                      : "No record found"}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}

      {!loading && (!data || data.length === 0) && (
        <div className="no-data">
          <div className="text-center py-5">
            <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
            <h5 className="text-muted">No {type === 'invoices' ? 'invoices' : 'transactions'} found</h5>
            <p className="text-muted">Try adjusting your filter criteria</p>
          </div>
        </div>
      )}

      {loading && (
        <div className="loading">
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading {type === 'invoices' ? 'invoices' : 'transactions'}...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataView; 